import { render, staticRenderFns } from "./OnlineResult.vue?vue&type=template&id=7ff50d1c&scoped=true"
import script from "./OnlineResult.vue?vue&type=script&lang=ts"
export * from "./OnlineResult.vue?vue&type=script&lang=ts"
import style0 from "./OnlineResult.vue?vue&type=style&index=0&id=7ff50d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff50d1c",
  null
  
)

export default component.exports